<template>
  <div class="fast-collect-detail-container">
    <div class="fast-collect-detail-back">
      <el-button @click="goBack" type="primary" size="mini"><jee-icon iconClass="fanhui"></jee-icon> 返回</el-button>
    </div>
    <div class="fast-collect-detail">
      <div class="fast-collect-detail-info">
        <div class="fast-collect-detail-img">
          <img :src="CollectDetail.logoImg + '_x2.png'" alt="">
        </div>
        <div class="fast-collect-detail-title">
          <h3>{{CollectDetail.title}}</h3>
          <p><el-button type="primary" size="mini" @click="goTo">立即使用</el-button></p>
        </div>
      </div>
      <div class="fast-collect-detail-rule">
        <h3>采集规则：</h3>
        <p>{{CollectDetail.rule}}</p>
      </div>
      <div class="fast-collect-detail-table">
        <h3>示例数据：</h3>
        <base-table
          v-bind="list"
        >
        </base-table>
      </div>
    </div>
  </div>
</template>

<script>
import FastCollectData from './FastCollectData'
import baseTable from '@/components/mixins/baseTable'
import { deepClone } from '@/utils'
export default {
  name: 'FastCollectDetail',
  mixins: [baseTable],
  data () {
    return {
      CollectDetail: {}, // 采集模板详情
      list: {
        showIndex: false,
        showSelection: false,
        showPagination: false,
        columns: [],
        data: []
      }
    }
  },
  mounted () {
    let _this = this
    // 初始化，判断快速采集模板类型
    if (_this.$route.query.type !== undefined) {
      let FastCollectIndex = FastCollectData.findIndex((item) => {
        return item.modelType === Number(_this.$route.query.type)
      })
      _this.CollectDetail = deepClone(FastCollectData[FastCollectIndex])
      _this.list.columns = _this.CollectDetail.tableTile.map(item => {
        let obj = {
          prop: item.key,
          label: item.name
        }
        return obj
      })
      _this.list.data = deepClone(_this.CollectDetail.exampleList)
    }
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    goTo () {
      let _this = this
      _this.$router.push({ name: 'FastCollectConfig', query: { type: _this.$route.query.type } })
    }
  }
}
</script>

<style lang="scss">
.fast-collect-detail-container{
  .fast-collect-detail-back{
    margin-bottom: 20px;
    .el-button{
      font-size:16px;
      width: 90px;
      padding: 9px 0;
    }
    .jee-svg-icon{
      vertical-align: -0.1em;
      font-size: 14px;
    }
  }

  .fast-collect-detail{
    h3{
      font-size:16px;
      font-weight:normal;
      color:rgba(51,51,51,1);
      line-height:21px;
      margin-bottom: 16px;
    }
    .fast-collect-detail-info{
      display: flex;
      align-items: center;
      border-bottom: 1px solid rgba(232,232,232,1);
      padding-bottom: 20px;
      margin-bottom: 30px;
      .fast-collect-detail-img{
        width: 88px;
        height: 88px;
        border: 1px solid rgba(232,232,232,1);
        border-radius: 14px;
        overflow: hidden;
        margin-right: 20px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .fast-collect-detail-title{
        flex: 1;
        h3{
          font-size:24px;
        }
        .el-button{
          width: 91px;
          height:32px;
          line-height: 32px;
          font-size: 14px;
          padding: 0;
        }
      }
    }
    .fast-collect-detail-rule{
      border-bottom: 1px solid rgba(232,232,232,1);
      padding-bottom: 30px;
      margin-bottom: 30px;
      p{
        font-size:14px;
        color:rgba(102,102,102,1);
        line-height:21px;
      }
    }
    .fast-collect-detail-table{
      h3{
        margin-bottom: 30px;
      }
      /deep/ .cell{
        white-space: nowrap;
      }
    }
  }
}
</style>
